var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useMemo } from 'react';
import classNames from 'classnames';
import { AlertCircle } from '@untitled-ui/icons-react';
export function FeaturedIcon(_a) {
    var _b = _a.icon, Icon = _b === void 0 ? AlertCircle : _b, className = _a.className, _c = _a.size, size = _c === void 0 ? 'md' : _c, _d = _a.color, color = _d === void 0 ? 'primary' : _d, _e = _a.variant, variant = _e === void 0 ? "fade" : _e, rest = __rest(_a, ["icon", "className", "size", "color", "variant"]);
    var variantClass = useMemo(function () {
        switch (variant) {
            case "fade":
                return "box-content bg-clip-padding bg-opacity-20 border-opacity-5";
            case "outline":
                return "box-border ring-2 ring-opacity-30 ring-inset ring-offset-2 border-2 border-opacity-10 bg-opacity-0";
        }
    }, [variant]);
    var sizeClass = useMemo(function () {
        switch (variant) {
            case "fade":
                switch (size) {
                    case "xl":
                        return "p-2.5 border-10";
                    case "lg":
                        return "p-2 border-8";
                    case "md":
                        return "p-1.5 border-6";
                    case "sm":
                        return "p-1 border-4";
                    default:
                        return "";
                }
            case "outline":
                return "p-1.5";
        }
    }, [variant, size]);
    var colourClass = useMemo(function () {
        switch (color) {
            case "error":
                return "text-error bg-error border-error ring-error";
            case "primary":
                return "text-primary bg-primary border-primary ring-primary";
            case "gray":
                return "text-gray bg-gray border-gray ring-gray";
            case "success":
                return "text-success bg-success border-success ring-success";
            case "warning":
                return "text-warning bg-warning border-warning ring-warning";
            default:
                return "";
        }
    }, [color]);
    return (React.createElement("div", __assign({}, rest, { className: classNames('size-min flex items-center justify-center rounded-full', sizeClass, colourClass, className, variantClass) }),
        React.createElement(Icon, { className: classNames('m-auto', {
                'size-7': size === 'xl',
                'size-6': size === 'lg',
                'size-5': size === 'md',
                'size-4': size === 'sm',
            }) })));
}
